import MessageHub from '../components/messages/MessageHub';

export default [
  {
    name: 'MessageHub',
    path: '/messages',
    component: MessageHub,
  },
]
